export enum ApplicationType {
    PROGRAM = "PROGRAM",
    EVENT ="EVENT"
}
